import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Drawer } from 'components/Ui';
import AnchorButton from 'components/ContentfulFields/Button';
import { getServerData } from 'utils/getServerData';
import { selectServiceLocation as setSelectedServiceLocation } from 'containers/PrimoAccount/actions';
import {
  selectServiceLocations,
  selectSelectedServiceLocationId,
} from 'containers/PrimoAccount/selectors';
import { selectHasCutoffBranch } from 'containers/Landing/selectors';
import { selectUserEmail } from 'containers/Authentication/selectors';
import Location from './Location';
import styles from './styles.scss';

const LocationsDrawer = ({ open, onClose }) => {
  const [migrationUrl, setMigrationUrl] = useState('/to-ready-refresh');
  const locations = useSelector(selectServiceLocations());
  const selectedLocId = useSelector(selectSelectedServiceLocationId());
  const hasCutoffBranch = useSelector(selectHasCutoffBranch());
  const email = useSelector(selectUserEmail());
  const dispatch = useDispatch();

  useEffect(() => {
    setMigrationUrl(getServerData('MIGRATION_URL'));
  }, []);

  if (!locations) return null;

  const handleSelectLocation = (serviceLocationId) => () => {
    dispatch(setSelectedServiceLocation({ serviceLocationId }));
    onClose();
  };

  const nonMigratedLocs = locations.filter(
    (loc) => loc.shipToBtbMgnStatus !== 'Migrated',
  );

  const migratedLocs = locations.filter(
    (loc) => loc.shipToBtbMgnStatus === 'Migrated',
  );

  const isSelected = (loc) => loc.id === selectedLocId;

  return (
    <Drawer
      headerTitle="Select Address"
      className={styles.drawer}
      open={open}
      onClose={onClose}
    >
      <article>
        <section>
          <ul>
            {nonMigratedLocs.map((loc) => (
              <li key={loc.id}>
                <Location {...loc} />
                <Button
                  text={isSelected(loc) ? 'Selected' : 'Select'}
                  onClick={handleSelectLocation(loc.id)}
                  color="dark"
                  className={styles.btn}
                  disabled={isSelected(loc)}
                />
              </li>
            ))}
          </ul>
        </section>
        {!!migratedLocs.length && (
          <section>
            <h3>Migrated Addresses</h3>
            <p className={styles.expo}>
              You can manage your deliveries for migrated locations at
              readyrefresh.com, while billing and invoices will remain on the
              current website.
            </p>
            <ul>
              {migratedLocs.map((loc) => (
                <li key={loc.id}>
                  <h5>
                    {!hasCutoffBranch ? 'MIGRATED' : 'MIGRATION IN PROGRESS'}
                  </h5>
                  <Location {...loc} />
                  {!hasCutoffBranch && (
                    <AnchorButton
                      text="Manage Deliveries"
                      to={`${migrationUrl}/?username=${email}&zipCode=${loc.postalCode}`}
                      color="dark"
                      className={styles.btn}
                    />
                  )}
                </li>
              ))}
            </ul>
          </section>
        )}
      </article>
    </Drawer>
  );
};

export default LocationsDrawer;
